export type SupportedLocales = {
  default: string;
  locales: Array<string>;
};

export const fetchSupportedLocales = async (): Promise<SupportedLocales> => {
  const response = await fetch(`/api/content/locales`);

  return response.json() as Promise<SupportedLocales>;
};
